<template>
  <section class="flex flex-col gap-2">
    <div class="py-4 md:py-0">
      <!-- Title container -->
      <div class="flex items-center justify-between">
        <h2 :class="['headline-sm', isUserOwner ? 'text-start' : 'w-full text-center']">
          Perfil de la empresa
        </h2>
        <!-- Go to Admin route -->
        <Link v-if="isUserOwner" :href="$route('company.profile.edit')">
          <Button class="btn-filled brand-green fill-white" icon="settings-filled">
            Modificar
          </Button>
        </Link>
      </div>
      <Divider class="hidden md:block md:!w-auto md:!mx-0" />
    </div>
    <section>
      <!-- Profile Info-Bullets container -->
      <div class="flex flex-col md:flex-row md:gap-2">
        <div
          v-for="(bullet, key) of companyInfoBullets"
          :key="key"
          class="flex gap-2 items-center md:flex-col md:gap-0 md:items-start"
        >
          <p class="text-chips md:px-[10px]">{{ bullet.name }}</p>
          <button class="btn-text-link">
            {{ bullet.found_value }}
          </button>
        </div>
      </div>
    </section>
    <div class="flex flex-col gap-2 md:gap-6 md:py-4">
      <ProfileSection v-if="company.multimedia" class="pb-2">
        <template v-slot:title>Galería</template>
        <template v-slot:content>
          <GalleryCarousel :media="company.multimedia" />
        </template>
      </ProfileSection>
      <ProfileSection v-if="company.description">
        <template v-slot:title>Acerca de</template>
        <template v-slot:content>{{ company.description }}</template>
      </ProfileSection>
      <ProfileSection v-if="company.company_mission">
        <template v-slot:title>Misión</template>
        <template v-slot:content>{{ company.company_mission }}</template>
      </ProfileSection>
      <ProfileSection v-if="company.company_vision">
        <template v-slot:title>Visión</template>
        <template v-slot:content>{{ company.company_vision }}</template>
      </ProfileSection>
      <ProfileSection v-if="company.company_values">
        <template v-slot:title>Valores</template>
        <template v-slot:content>{{ company.company_values }}</template>
      </ProfileSection>
    </div>
  </section>
</template>

<script>
import { Link } from '@inertiajs/inertia-vue'
import getPropertiesIfExistFromDataObjectMixin from '@/getPropertiesIfExistFromDataObject.mixin.js'
import ProfileSection from '@/Components/ProfileSection'
import GalleryCarousel from '@/Components/GalleryCarousel'
import GalleryYoutubeEmbed from '@/Components/GalleryYoutubeEmbed'
import ButtonIcon from '@/Components/ButtonIcon'
import Button from '@/Components/Button'
import Divider from '@/Components/Divider'

export default {
  name: 'CompanyProfileMainTab',
  components: {
    Link,
    ProfileSection,
    GalleryCarousel,
    GalleryYoutubeEmbed,
    ButtonIcon,
    Button,
    Divider,
  },
  mixins: [getPropertiesIfExistFromDataObjectMixin],
  props: {
    company: {
      required: true,
      type: Object,
    },
    isUserOwner: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    companyInfoBullets() {
      return this.getPropertiesIfExistFromDataObject('company', {
        company_category: { name: 'Rubro' },
        location: { name: 'Ubicación' },
        company_size: { name: 'Tamaño' },
      })
    },
  },
}
</script>

<style></style>
